import { Component, HostListener, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { UserConstant } from 'src/app/constants/label-constants';
import { UserModel } from 'src/app/models/user-model';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
import { UserViewComponent } from './user-view/user-view.component';
import { StatusDialogboxComponent } from '../status-dialogbox/status-dialogbox.component';
import { UserAddEditComponent } from './user-add-edit/user-add-edit.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent {
  userForm: FormGroup = this.formBuilder.group({});
  UserList: any = [];
  showData: boolean = false;
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'FirstName', 'LastName', 'EmailId', 'MobileNo', 'AdminRoleName', 'isActive', 'Action'];
  dataSource: MatTableDataSource<UserModel> = new MatTableDataSource();
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  CommonConstant: any = [];
  NoRecordFound: any = [];
  UserConstant: any = [];
  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.userForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }
  userStatusObj: any = {};
  userDeleteObj: any = {};

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    private router: Router,
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private EncrDecr: EncrDecrService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.UserConstant = UserConstant;
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.getUserList();
    this.sharedService.setData('User');
  }

  getUserList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.user.GetUserList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.UserList = response.data;
          this.dataSource.data = this.UserList;
          if (this.UserList.length > 0) {
            TotalRecords = this.UserList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  SortChange(event) {
    this.sortDirection = event.direction ? event.direction : 'asc';
    this.SortColumn = event.active;
    this.getUserList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getUserList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getUserList();
      this.searchClose = true;
    }
  }

  pageChanged(event) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getUserList();
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getUserList();
    this.searchClose = false;
  }

  onView(userId: number) {
    var encrypted = this.EncrDecr.set('123456$#@$^@1ERF', userId);
    this.router.navigate(['user/view', encrypted]);
  }

  AddUser(userId: number) {
    const modalRef = this.modalService.open(UserAddEditComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.userId = userId;
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getUserList();
      }
    }).catch((error) => {
    });
  }

  UserListDetail(userId: number) {
    const modalRef = this.modalService.open(UserViewComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.userId = userId;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  Deletepopup(userId: number, firstName: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.userDeleteObj = {
      userId: userId,
      firstName: firstName,
      element: 'user'
    }
    modalRef.componentInstance.userDeleteObj = this.userDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.getUserList();
      }
    }).catch((error) => {
    });
  }

  onStatus(userId: number, userName: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.userStatusObj = {
      userId: userId,
      userName: userName,
      activeUser: active
    }
    modalRef.componentInstance.userStatusObj = this.userStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.UserList.forEach((element: { userId: number; isActive: boolean; }) => {
          if (element.userId == userId) {
            element.isActive = active ? false : true
          }
        });
      }
    }).catch((error) => {
    });
  }
}
